import React from 'react';
import { Alert, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { FONT_ENUM } from '../../types/global/fonts.types';
import type { ICampaignWorkspaceCapacity } from '../../utils/campaignParticipationGate';
import { PARTICIPATION_GATE_CAPACITY_INFO } from '../../utils/campaignParticipationGate';

const GOLD = '#ffc965';

export interface CampaignCapacityInfoBannerProps {
    capacity?: ICampaignWorkspaceCapacity | null;
    sx?: object;
}

export function CampaignCapacityInfoBanner({ capacity, sx }: CampaignCapacityInfoBannerProps) {
    if (!capacity?.is_at_capacity) return null;

    const filled = capacity.filled_positions;
    const total = capacity.total_participants_count;
    const slotsLabel =
        typeof filled === 'number' && typeof total === 'number' && total > 0
            ? ` (${filled}/${total} spots filled)`
            : '';

    return (
        <Alert
            severity="info"
            icon={<InfoOutlinedIcon sx={{ color: GOLD }} />}
            sx={{
                mb: 2,
                bgcolor: 'rgba(255, 201, 101, 0.06)',
                border: '1px solid rgba(255, 201, 101, 0.22)',
                color: '#fff',
                alignItems: 'flex-start',
                ...sx,
            }}>
            <Typography sx={{ fontFamily: FONT_ENUM.MAIN_BOLD, fontSize: 13, color: '#fff', mb: 0.25 }}>
                Campaign full{slotsLabel}
            </Typography>
            <Typography sx={{ fontSize: 13, color: 'rgba(255,255,255,0.75)', lineHeight: 1.5 }}>
                {PARTICIPATION_GATE_CAPACITY_INFO}
            </Typography>
        </Alert>
    );
}
